import { useMemo } from 'react';

import { StockInfo } from '@ndvr/market-data-api';

import { useNDVR1500Stocks } from '@/hooks/market-data-queries';

interface UseStockDataReturn {
    stocks: StockInfo[];
    stocksMap: Map<string, StockInfo>;
    isLoading: boolean;
    isFetching: boolean;
}

export const useStockData = (): UseStockDataReturn => {
    const {
        data: ndvr1500,
        isLoading,
        isFetching,
    } = useNDVR1500Stocks({ refetchOnMount: false, refetchOnWindowFocus: false });

    const stocksMap = useMemo(() => {
        if (!ndvr1500) return new Map<string, StockInfo>();
        return new Map(ndvr1500.map((stock) => [stock.shareId, stock]));
    }, [ndvr1500]);

    return {
        stocks: ndvr1500 || [],
        stocksMap,
        isLoading,
        isFetching,
    };
};
